
<template>
    <v-layout style="position: relative; min-height: 200px;" align-center justify-center>
        <loading v-if="loadingActivities"></loading>  
        <v-flex v-else>
            <v-layout wrap>
                <v-flex xs12 sm2>
                    <v-btn right class="primary mx-4"  @click="addActivity()" >Add Activity</v-btn>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs12 sm3>
                    <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                </v-flex>
            </v-layout>
            <v-data-table :headers="headers" :items="activities" :pagination.sync="pagination" hide-actions :search="search" :no-results-text="noSearchResults">
                <template v-slot:items="props">
                    <td>{{ props.item.ActivityCode }}</td>
                    <td>{{ props.item.Description }}</td>
                    <td>
                        <v-checkbox hide-details color="primary" v-model="props.item.Status" disabled></v-checkbox>
                    </td>
                    <td>
                        <span v-for="(departments, index) in props.item.Departments" :key="index">{{ nameWithComma(index, 'ActivityDepartmentCode' , props.item.Departments) }} </span>
                    </td>
                    <td>
                        <span v-for="(units, index) in props.item.Units.filter(u=> u.IsActive)" :key="index">{{ nameWithComma(index, 'UnitOfMeasure' , props.item.Units.filter(u=> u.IsActive)) }} </span>
                    </td>
                    <td>
                        <v-btn right class="primary" @click="editActivity(props.item)">Edit</v-btn>
                    </td>
                </template>
            </v-data-table>
            
            <v-dialog :value="showEditActivity" max-width="500px" persistent @keydown.esc="handleCloseEdit()">
                <activity-edit v-if="showEditActivity" :editData="targetActivity" @close="handleCloseEdit()">
                </activity-edit>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
import Loading from '@/components/generic/Loading.vue';
import ActivityEdit from '@/components/cropwork/EditActivity.vue';

import {
    mapState
} from 'vuex';

export default {
    components: {
        Loading,
        ActivityEdit,
    },
    props: [    
        'loading'
    ],
    data(){
        return {
            showEditActivity: false,
            targetActivity: null,
            search: "",
            pagination: {
                rowsPerPage: -1
            }
        };
    },
    computed: {
        ...mapState("CropWorkStore", [
            "activities",
            "divisions",
            "loadingActivities",
        ]),
        headers() {
            return  [
                { text: 'Activity Code', value: 'ActivityCode' },
                { text: 'Description', value: 'Description' },
                { text: 'Active', value: 'Status'},
                { text: 'Activity Department Codes', value: '', sortable: false},
                { text: 'Units of Measure', value: 'Units', sortable: false },
                { text: 'Edit', value: 'Edit', sortable: false }
            ]
        },
        noSearchResults() {
            return "Your search for \""+ this.search + "\" returned no results."
        },
        plantID() {
            return this.$route.params.plantID;
        },
    },
    methods: {
        nameWithComma(index, nameKey, list) {
            if(index != list.length - 1){
                return `${list[index][nameKey]},`
            }
            return `${list[index][nameKey]}`
        },
        editActivity(item) {
            this.showEditActivity = true;
            // object assign is a lie and copies any child object references instead of reassigning them
            this.targetActivity = JSON.parse(JSON.stringify(item))
            this.targetActivity.Units = this.targetActivity.Units.map(u=> {
                u.Editing = false;
                return u;
            })
        },
        addActivity() {
            this.showEditActivity = true;
            this.targetActivity = {
                CropWorkActivityID:-1,
                ActivityCode: "",
                Description: "",
                PlantID: this.plantID,
                Departments:[],
                Units:[],
                RequireDivision: false,
                RequireLocation: false,
                RequireProduct: false,
                RequireVariety: false,
                Status: true,
            }
        },
        handleCloseEdit() {
            this.showEditActivity = false;
            this.targetActivity = null;
        },
    }
}
</script>